module.exports = __webpack_public_path__ + "img/promo-1.d4c56695.jpg";